export const removeChatMixin = {
  mounted() {
    //Hide chat
    this.shh();
    let i = setInterval((ctx = this) => {
      ctx.shh();
      let a = document.getElementById("__replain_widget");
      if (a && a.classList.contains("shh")) {
        clearInterval(i);
      }
    }, 400);
  },
  methods: {
    shh() {
      let a = document.getElementById("__replain_widget");
      if (a) {
        if (!a.classList.contains("shh")) {
          a.classList.add("shh");
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    let a = document.getElementById("__replain_widget");
    a.classList.remove("shh");
    next();
  }
};



// WEBPACK FOOTER //
// ./src/plugins/removeChatMixin.js